import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
  }
  html{
    font-size: 10px;
  }
  body {
    background: ${({ theme }) => theme.colors.body};
    font-family: 'Poppins',-apple-system,'Microsoft YaHei', sans-serif;
    font-size: 1.4rem;
    overflow-x: hidden;
    position: relative;
    overflow: visible;
    /* overflow-y: ${(props) =>
      props.theme.isFullscreenOpen ? 'hidden' : 'visible'}; */
  }

  a {
    text-decoration: none;
    color: rgba(0, 0, 0, 0.8);
  }
  ul {
    list-style: none;
  }

  img {
    max-width: 100%;
  }
  body::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background-color:rgba(210, 210, 210, 0.48);
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 0;
  }

  body::-webkit-scrollbar-thumb {
    background-color: #cbcbcb;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 0;
  }

  ::-webkit-scrollbar {
    width: 2px;
    height: 2px;
    background-color:rgba(210, 210, 210, 0.48);
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 0;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(97, 97, 97, 0.4);
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 0;
  }
  
`

export default GlobalStyles
